(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baseline-benefits-tab"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('baseline-benefits'))customElements.define('baseline-benefits',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.buttons=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[role="tabpanel"]')];this.buttons.forEach((button,index)=>{button.addEventListener('click',()=>this.activate(index));button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();let next=event.key==='Home'?0:event.key==='End'?this.buttons.length-1:(index+(event.key==='ArrowRight'?1:-1)+this.buttons.length)%this.buttons.length;this.activate(next,true);});});this.addEventListener('shopify:block:select',event=>{const index=this.panels.findIndex(panel=>panel.dataset.blockId===event.detail.blockId);if(index>=0)this.activate(index);});}
 activate(index,focus=false){this.buttons.forEach((button,i)=>{const active=i===index;button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;this.panels[i].hidden=!active;});if(focus)this.buttons[index].focus();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["baseline-custom-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('baseline-review-gallery')) {
  customElements.define('baseline-review-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reviews = Array.from(this.querySelectorAll('.cr-list > .cr-review'));
      this.pagination = this.querySelector('.cr-pagination');
      this.reviewStatus = this.querySelector('.cr-pagination-status');
      this.visibleReviews = Math.min(4, this.reviews.length);
      this.updateReviews();
      const showMore = this.querySelector('.cr-show-more');
      if (showMore) showMore.addEventListener('click', () => {
        const firstNewReview = this.reviews[this.visibleReviews];
        this.visibleReviews = Math.min(this.visibleReviews + 5, this.reviews.length);
        this.updateReviews();
        if (firstNewReview) {
          firstNewReview.setAttribute('tabindex', '-1');
          firstNewReview.focus({ preventScroll: true });
        }
        this.reviewStatus.textContent = 'Showing ' + this.visibleReviews + ' of ' + this.reviews.length + ' reviews.';
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.reviews.findIndex(review => review.dataset.reviewId === event.detail.blockId);
        if (index < 0) return;
        this.visibleReviews = Math.max(this.visibleReviews, index + 1);
        this.updateReviews();
      }, options);
      this.dialog = this.querySelector('.cr-lightbox');
      if (!this.dialog) { this.controller = null; return; }
      this.items = Array.from(this.querySelectorAll('[data-gallery-id]'));
      this.index = 0;
      this.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-gallery-id], [data-gallery-open]');
        if (!trigger || !this.contains(trigger)) return;
        const id = trigger.dataset.galleryId || trigger.dataset.galleryOpen;
        const index = this.items.findIndex(item => item.dataset.galleryId === id);
        if (index < 0 || typeof this.dialog.showModal !== 'function') return;
        event.preventDefault();
        this.opener = trigger;
        this.showPhoto(index);
        if (!this.dialog.open) this.dialog.showModal();
      }, options);
      this.dialog.querySelector('[data-viewer-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.querySelector('[data-viewer-prev]').addEventListener('click', () => this.showPhoto(this.index - 1), options);
      this.dialog.querySelector('[data-viewer-next]').addEventListener('click', () => this.showPhoto(this.index + 1), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.showPhoto(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
      const stage = this.dialog.querySelector('.cr-lightbox__stage');
      stage.addEventListener('touchstart', event => {
        this.touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { ...options, passive: true });
      stage.addEventListener('touchend', event => {
        if (!this.touchStart || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - this.touchStart.x;
        const dy = event.changedTouches[0].clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) this.showPhoto(this.index + (dx < 0 ? 1 : -1));
      }, { ...options, passive: true });
    }
    updateReviews() {
      this.reviews.forEach((review, index) => { review.hidden = index >= this.visibleReviews; });
      if (this.pagination) this.pagination.hidden = this.visibleReviews >= this.reviews.length;
    }
    showPhoto(index) {
      if (!this.items.length) return;
      this.index = (index + this.items.length) % this.items.length;
      const item = this.items[this.index];
      const image = this.dialog.querySelector('[data-viewer-image]');
      image.src = item.href;
      image.alt = item.dataset.alt || 'Customer review photo';
      this.dialog.querySelector('[data-viewer-author]').textContent = item.dataset.author || 'Customer photo';
      const rating = Math.max(0, Math.min(5, Number(item.dataset.rating) || 0));
      const stars = this.dialog.querySelector('[data-viewer-stars]');
      stars.textContent = '★'.repeat(Math.round(rating));
      stars.setAttribute('aria-label', rating + ' out of 5 stars');
      stars.hidden = !rating;
      this.dialog.querySelector('[data-viewer-counter]').textContent = (this.index + 1) + ' / ' + this.items.length;
      this.dialog.querySelector('[data-viewer-prev]').hidden = this.items.length < 2;
      this.dialog.querySelector('[data-viewer-next]').hidden = this.items.length < 2;
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
